/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Taxpayer_Id_TakenInputs */

const es_co2_error_taxpayer_id_taken = /** @type {(inputs: Error_Taxpayer_Id_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya existe una empresa con este NIT.`)
};

/**

* @param {Error_Taxpayer_Id_TakenInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_taxpayer_id_taken = /** @type {((inputs?: Error_Taxpayer_Id_TakenInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Taxpayer_Id_TakenInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_taxpayer_id_taken(inputs)
});